import React from 'react';
import PropTypes from 'prop-types';
import AccountPlayerPlaysRow from './AccountPlayerPlaysRow';
import AccountPlayerPlaysHeader from './AccountPlayerPlaysHeader';
import TableFooter from '../helpers/TableFooter';
import { isEmpty } from 'lodash';
import { tableNoResultsDefault, tableSpinnerDefault } from '../helpers/TableHelpers';

const COLUMNS_COUNT = 6;

const AccountPlayerPlays = ({ id, meta, plays, onPageChange, onSortChange }) => {
  const rows = plays.map(row => (<AccountPlayerPlaysRow key={`${row.id}`} data={row} />));
  return (
    <div className='u-margin-bottom--gutter' id='plays'>
      <strong>Play Activity</strong>
      <div className='u-margin-top--small cs-bg--light table-scroll'>
        <table className='o-table o-table--bordered'>
          <AccountPlayerPlaysHeader id={id} meta={meta} onSortChange={onSortChange} />
          <tbody>
            { (isEmpty(plays) && meta.totalPages === 0) ? tableNoResultsDefault(COLUMNS_COUNT) :
              isEmpty(plays) ? tableSpinnerDefault(COLUMNS_COUNT) : rows }
          </tbody>
        </table>
      </div>
      { meta.totalCount > 0 && <TableFooter meta={meta} onPageChange={onPageChange} /> }
    </div>
  );
}

AccountPlayerPlays.propTypes = {
  id: PropTypes.number.isRequired,
  meta: PropTypes.object.isRequired,
  plays: PropTypes.arrayOf(PropTypes.object).isRequired,
  onPageChange: PropTypes.func.isRequired,
  onSortChange: PropTypes.func.isRequired,
}

export default AccountPlayerPlays;
